<template>

    <div class="animated fadeIn">

        <b-row class="text-center mt-4">
            <b-col>
                <h4>Gracias por dedicar tu tiempo a responder a esta breve encuesta.</h4>
            </b-col>
        </b-row>

        <b-row class="text-center mt-2">
            <b-col>
                <h4>Solo le llevará unos segundos completarla.</h4>
            </b-col>
        </b-row>

        <b-row class="text-center mt-2">
            <b-col>
                <h4>Las respuestas se utilizarán únicamente para garantizar y mejorar los servicios que desde ATA ofrecemos a los Autónomos.</h4>
            </b-col>
        </b-row>

        <b-row class="text-center mt-4">
            <b-col>
                <button @click="initSurvey" class="btn btn-primary">INICIAR ENCUESTA</button>
            </b-col>
        </b-row>

        <b-row class="mt-4 notes">
            <b-col>
                <span>Información detallada sobre la encuesta:</span>
                <ul>
                    <li>Duración estimada en completarse: inferior a un minuto.</li>
                    <li>Hay 4 preguntas que tratan sobre su <strong>nivel de satisfacción</strong> en relación a la consulta que ha realizado a ATA.</li>
                    <li>Hay una pregunta opcional para indicar comentarios y/o observaciones.</li>
                    <li>La escala de valoración es de 1 a 5, donde <strong>1</strong> significa <strong>'Nada Satisfecho/a'</strong> y <strong>5</strong> significa <strong>'Plenamente Satisfecho/a'</strong>.</li>
                    <li>La información recopilada se utilizará de forma <strong>anónima</strong> con fines estadísticos y para mejorar el servicio ofrecido por ATA.</li>
                </ul>
            </b-col>
        </b-row>

    </div>

</template>

<script>
    export default {
        name: "Intro",
        methods: {
            initSurvey() {
                this.$emit('initSurvey', true);
            }
        }
    }
</script>

<style scoped>
    .notes {
        font-size: 12px;
    }
</style>